"use strict";

import {
    default as React,
    Component,
} from 'react';
import { FormatNumber } from '../../../components/formatNumber';

import { series } from '../utils/series';

export default class BarHorizontal extends Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        onMouseOver: (d) => {},
        onMouseOut: (d) => {},
        barClassName: 'react-d3-basic__bar_horizontal'
    };

    triggerOver(data, e) {
        this.props.onMouseOver(e, data)
    }

    triggerOut(data, e) {
        this.props.onMouseOut(e, data)
    }


    _calcValueLabelPos(orient, zeroBase, xVal, hShift) {
        const {
            xScaleSet,
        } = this.props;

        let valueLabelX;
        let textAnchor;

        if(orient === 'left') {
            valueLabelX = (0 + hShift);
            textAnchor = 'left';
        } else if (['center', 'middle', 'central'].indexOf(orient) > -1) {
            valueLabelX = (Math.abs(zeroBase - xScaleSet(xVal))/2 + hShift);
            textAnchor = 'middle';
        } else if (orient === 'rightBarIn') {
            valueLabelX = (Math.abs(zeroBase - xScaleSet(xVal)) + hShift);
            textAnchor = 'end';
        } else if (orient === 'rightBarOut') {
            valueLabelX = (Math.abs(zeroBase - xScaleSet(xVal)) + hShift);
            textAnchor = 'left';
        } else if (orient === 'right') {
            valueLabelX = (this.props.xScaleSet.range()[1] + this.props.margins.right + hShift);
            textAnchor = 'end';
        }

        return {x: valueLabelX, textAnchor: textAnchor};
    }

    _mkBar(dom) {
        const {
            xScaleSet,
            yScaleSet,
        } = this.props;

        const that = this;
        let dataset = series(this.props, true)[0];

        const {
            show,
            hShift,
            vShift,
            orient,
            format,
        } = dataset.values;

        let domain = xScaleSet.domain();
        let zeroBase;

        if (domain[0] * domain[1] < 0) {
            zeroBase = xScaleSet(0);
        } else if (((domain[0] * domain[1]) >= 0) && (domain[0] >= 0)) {
            zeroBase = xScaleSet.range()[0];
        } else if (((domain[0] * domain[1]) >= 0) && (domain[0] < 0)) {
            zeroBase = xScaleSet.range()[1];
        }

        return (
            <g className="barChartArea">
                {
                    dataset.data.map((bar, i) => {
                        let labelPosProps = this._calcValueLabelPos(orient, zeroBase, bar.x, hShift);
                        return (
                            <g key={i} className= {`${dataset.className}`}>
                                <rect
                                    className= {`bar`}
                                    y= {yScaleSet(bar.y) || yScaleSet(bar.y) === 0? yScaleSet(bar.y) : -10000}
                                    x= {bar.x > 0 ? zeroBase: (zeroBase - Math.abs(zeroBase - xScaleSet(bar.x)))}
                                    height= {yScaleSet.bandwidth()}
                                    width= {bar.x < domain[0] ? 0: Math.abs(zeroBase - xScaleSet(bar.x))}
                                    style= {Object.assign({}, dataset.style, {fill: bar.color})}
                                    onMouseOut={that.triggerOut.bind(this, bar)}
                                    onMouseOver={that.triggerOver.bind(this, bar)}
                                />
                                { show ? (
                                    <FormatNumber
                                        useLocale={ this.props.useLocale }
                                        renderElement='text'
                                        renderProps={ {
                                            y: (yScaleSet(bar.y) + yScaleSet.bandwidth()/2 + vShift) || yScaleSet(bar.y) === 0 ?
                                                (yScaleSet(bar.y)+ yScaleSet.bandwidth()/2 + vShift ) : -10000,
                                            ...labelPosProps,
                                            alignmentBaseline: "central",
                                            className: dataset.values.className
                                        } }
                                        suffix='%'
                                    >
                                        { bar.x }
                                    </FormatNumber>
                                ) : null }
                            </g>
                        )
                    })
                }
            </g>
        )
    }

    render() {
        let bar = this._mkBar();

        return (
            <g>
                {bar}
            </g>
        )
    }
}
